<template>
    <b-container fluid class="mt-80px">
        <div class=" card choose-template-top-form p-0" >
             <div class="card-header">
                 Registered Case Upload
             </div>
            <div class="card-body">
                <div v-show="programCreated" class="form-group inputDnD row">
                    <div class="col-md-6">
                        <form enctype="multipart/form-data" ref="fileUploadForm">
                            <label class="sr-only" for="inputFile">File Upload</label>
                                <input type="file" class="form-control-file text-primary font-weight-bold" id="inputFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="readUrl($event)" v-bind:data-title="fileName">
                        </form>
                        <button class="btn btn-sm mr-2" style="background-color: #238cbb !important;color:#fff" @click="getExcel()">Download Template</button>
                        <button class="btn btn-sm" style="background-color: #238cbb !important;color:#fff" @click="uploadFile()" >Submit</button> <br/><br/>
                        <b-alert variant="danger" show>Note*: Kindly enter your ORW credential in the 'username' column before uploading the template.</b-alert>
                    </div>
                    <div class="col-md-6 ">
                    </div>
                </div>
                <div v-show="!programCreated">
                    No program created, kinldy create a program to proceed.
                </div>  
            </div>
        </div>
    </b-container>
</template>
<script>
import ApiServices from '../service/ApiServices';
export default {
    name: "Upload",
    data() {
        return { 
            userData : JSON.parse(sessionStorage.getItem("userData")),
            fileName: 'Upload a file',
            programCreated : true,
            programid : '',
        }
    },
    methods : {
        getExcel(){
            let instace = {
                "programid":this.userData.programid
            }
            ApiServices.RestPostCall('program/instance/download/index/template',instace).then(res => {
                console.log(res)
                let a = document.createElement('a');
                a.href = res.fileurl
                a.target = '_blank'
                a.click()
            })
        },
        readUrl(event) {
            let Name = event.target.files[0].name;
            this.fileName = Name
        },
        uploadFile() {
            
            if(document.getElementById('inputFile').files[0]){
                this.$root.isLoading = true;
                var frmData = new FormData();
                var programid = ''
                console.log(document.getElementById('inputFile').files[0])
                frmData.append("file", document.getElementById('inputFile').files[0])
                console.log(frmData)
                var reqObj = {
                    "username":this.userData.username,
                    "programid":this.userData.programid
                    }
                frmData.append("inputJsonString",JSON.stringify(reqObj))
                ApiServices.RestPostMaltipart('program/instance/patient/bulk/register',frmData).then(res=>{
                    this.$root.isLoading = false;
                    if(res.status == 'success'){
                        this.toast('success','File uploaded sucessfully!')
                        this.fileName = 'Drag and drop a file'
                        this.$refs.fileUploadForm.reset()
                        let a = document.createElement('a');
                        a.href = res.fileurl
                        a.target = '_blank'
                        a.click()
                    }
                }).catch(err=>{
                    this.$root.isLoading = false;
                })
            }else{
                this.toast("danger", "Kindly select file to upload", "Error");
            }
        },
        toast(toastType = 'success', message, title='Success', append = false) {
            this.$bvToast.toast(`${message}`, {
                title: `${title}`,
                variant: toastType,
                solid: true,
                appendToast: append,
                toaster: 'b-toaster-top-center'
            })
        }
    },
    mounted(){
        // this.programCreated = JSON.parse((sessionStorage.getItem('programCreated')))
        // console.log(this.programCreated)
        // if(this.programCreated){
        //     var reqObjTemp = {"userid":this.userData.userid}
        //     ApiServices.RestPostCall('api/rtmpro/component/appdetails',reqObjTemp).then(res => {
        //         console.log(res)
        //         this.programid = Object.values(res.data)[0].details.program[0].id
        //     })
        // }
    }
}
</script>